
<header>
   <app-header></app-header>
</header>

<!-- Left Panel -->
<div class="side-panel side-panel--left" *ngIf="!fullWidth && !noAds">
  <app-ninja-banner></app-ninja-banner>
  <ng-container *ngIf="ads">
    <app-bulenox-banner
      [optionLabel]="ads.option1.optionLabel"
      [discount]="ads.option1.discount"
      [couponCode]="ads.option1.couponCode"
      [expiry]="ads.option1.expiry"
      [link]="ads.option1.link"
      [accounts]="ads.option1.accounts">
    </app-bulenox-banner>
  </ng-container>
</div>

<!-- Right Panel -->
<div class="side-panel side-panel--right" *ngIf="!fullWidth && !noAds">
  <app-ninja-banner></app-ninja-banner>
  <ng-container *ngIf="ads">
    <app-bulenox-banner
      [optionLabel]="ads.option2.optionLabel"
      [discount]="ads.option2.discount"
      [couponCode]="ads.option2.couponCode"
      [expiry]="ads.option2.expiry"
      [link]="ads.option2.link"
      [accounts]="ads.option2.accounts">
    </app-bulenox-banner>
  </ng-container>
</div>

<main>
    <div class="container mrgn-bttm-md">
        <div class="row">
            <div class="col-xs-12" >
              <ng-content></ng-content>
            </div>
        </div>
    </div>
</main>

<!-- Bottom Ad Strip — visible only on small screens (<1100px) -->
<div class="bottom-ad-strip" *ngIf="!fullWidth && !noAds">
  <span class="bottom-ad-label">SPONSORED</span>
  <div class="bottom-ad-row">
    <app-ninja-banner></app-ninja-banner>
    <ng-container *ngIf="ads">
      <app-bulenox-banner
        [optionLabel]="ads.option1.optionLabel"
        [discount]="ads.option1.discount"
        [couponCode]="ads.option1.couponCode"
        [expiry]="ads.option1.expiry"
        [link]="ads.option1.link"
        [accounts]="ads.option1.accounts">
      </app-bulenox-banner>
      <app-bulenox-banner
        [optionLabel]="ads.option2.optionLabel"
        [discount]="ads.option2.discount"
        [couponCode]="ads.option2.couponCode"
        [expiry]="ads.option2.expiry"
        [link]="ads.option2.link"
        [accounts]="ads.option2.accounts">
      </app-bulenox-banner>
    </ng-container>
  </div>
</div>

<footer class="mrgn-tp-lg" *ngIf="!hideFooter()">
    <app-footer></app-footer>
</footer>
